import type { AxiosInstance } from 'axios';
import { reachabilityMonitor } from './reachability';
import { syncNow } from './runtime';

export { syncNow };

export function setupAutoSync(client: AxiosInstance): () => void {
  return reachabilityMonitor.subscribe((snapshot) => {
    if (snapshot.isReachable) void syncNow(client);
  });
}
